import { render, staticRenderFns } from "./BlockTravelInformationZoneTicket.vue?vue&type=template&id=6552b8ad&"
import script from "./BlockTravelInformationZoneTicket.vue?vue&type=script&lang=js&"
export * from "./BlockTravelInformationZoneTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports